import React, { useMemo } from 'react';

import { useIntl } from 'react-intl-next';

import AvatarIcon from '@atlaskit/icon/core/person-avatar';

import type { ForYouConfig } from '../../../common/forYouTypes';
import type {
	ButtonItemConfig,
	LinkItemConfig,
	NavItemConfigInternal,
} from '../../../common/types';

import { FOR_YOU_TEST_ID } from './constants';
import { messages } from './messages';

const elemBefore = <AvatarIcon label="" />;

export function useForYouNavItem(forYou: ForYouConfig): [string, NavItemConfigInternal][] {
	const { formatMessage } = useIntl();
	// Some type magic so we can get the dependencies right for the memo and keep TypeScript happy.
	const forYouItem = (forYou as Extract<ForYouConfig, ForYouConfig>)?.forYouItem;

	return useMemo(() => {
		if (!forYouItem) {
			return [];
		} else {
			// Business rule: The forYouItem is not reorderable or hideable.
			const common = {
				elemBefore,
				isHideable: false,
				isReorderable: false,
				isSelected: forYouItem.isSelected,
				label: formatMessage(messages.label),
				testId: FOR_YOU_TEST_ID,
			};

			const value: LinkItemConfig | ButtonItemConfig = forYouItem.url
				? {
						type: 'link',
						href: forYouItem.url,
						onClick: forYouItem.onClick,
						...common,
					}
				: {
						type: 'button',
						onClick: forYouItem.onClick,
						...common,
					};

			return [[forYouItem.menuItemId ?? 'global.sidebar.forYou', value]];
		}
	}, [forYouItem, formatMessage]);
}
